var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.6 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,21.2h-56.5v-7.1c0-7.8-6.3-14.1-14.1-14.1h-28.2c-7.8,0-14.1,6.3-14.1,14.1v7.1H14.1c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h169.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6,226.2c1,11.8,10.9,20.8,22.7,20.8h95c11.8,0,21.7-9,22.7-20.8l14.5-162.7H14.1l14.5,162.7ZM127,105.9c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1v98.8c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1v-98.8ZM91.7,105.9c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1v98.8c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1v-98.8ZM56.5,105.9c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1v98.8c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1v-98.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.867ca6b24e179fb3cc65bf3cfb810840.svg";
export { ForwardRef as ReactComponent };